<template>
	<div class="login">
		<!-- 登录页 -->
		<div v-if="!isTestPanelShow" class="login-container">
			这是登录页
		</div>
		<!-- 调试面板 -->
		<div v-if="isTestPanelShow" class="test-container">
			<div class="group-box">
				<h2>view页面列表7</h2>
				<div class="content-box">
					<van-button v-for="(item, index) of viewList" :key="index" class="nav-btn" @click="go(item)">{{
						(item.meta && item.meta.title) || item.name
					}}</van-button>
				</div>
			</div>
			<div class="group-box">
				<h2>demo页面列表</h2>
				<div class="content-box">
					<van-button v-for="(item, index) of demoList" :key="index" class="nav-btn" @click="go(item)">{{
						(item.meta && item.meta.title) || item.name
					}}</van-button>
				</div>
			</div>
			<tab-bar />
		</div>
	</div>
</template>

<script>
import tabBar from '../../components/navigation/tab-bar'
import { viewRouters, demoRouters } from '../../router/index.js'
export default {
	name: 'login',
	components: {
		tabBar
	},
	props: {},
	data() {
		return {
			viewList: viewRouters,
			demoList: demoRouters,
			isTestPanelShow: true // 调试面板显示
		}
	},
	methods: {
		go(item) {
			this.$router.push(item.path)
		}
	},
	mounted() {
		// this.$common.loading()
	}
}
</script>

<style lang="less" scoped>
@import './index.less';
.login {
	width: 100%;
	min-height: 100%;
	background: #f0f2f5;
	.group-box {
		h2 {
			font-size: 14px;
			padding: 16px;
			color: rgba(69, 90, 100, 0.6);
		}
		.content-box {
			margin: 0 10px -10px 10px;
			.nav-btn {
				margin: 0 10px 10px 0;
			}
		}
	}
}
</style>
